import {
  SAVE_USER_STATE,
  SHOW_SPINNER,
  SHOW_NOTIFICATION,
  HIDE_SPINNER,
  GET_STATS,
} from "../types";
import { saveUserSatate } from "./index";
import statsConfig from "../../config/stats.json";
import { clearOutdatedData } from "../../components/Statistics/statsCalc";
import api from "../../api";
import sessionErrHandler from "./sessionErrHandler";
import { getTimestamp, getDailyTimestamp } from "../../tools";
// import statsInfo from '../../config/stats.json';

// "PRESENTATION": "p",
// "ACTIVATION": "a",
// "EVALUATION": "e",
// "SUPPLEMENT": "s",
// "GAMES": "g",
// "MEDIA": "m",
// "NOTES": "n"

let waitingForStats = false;

export const getCourseStats =
  (id = false, email = false) =>
  async (dispatch, getState) => {
    const state = getState();
    const stats = state.stats.courseStats;
    if (waitingForStats) return;
    const courseId = id ? id : state.userState.currentCourseId;
    const currentTime = getTimestamp();
    if (stats.courseId !== courseId || currentTime - stats.time > 60 || email) {
      waitingForStats = true;
      dispatch({ type: SHOW_SPINNER, payload: "Pobieram statystyki" });
      let response;

      try {
        if (email) {
          const url = `/course/time/report/${courseId}/user`;
          response = await api.post(url, { email });
        } else {
          const url = `/course/time/report/${courseId}`;
          response = await api.get(url, { withCredentials: true });
        }
        if (response.status === 200) {
          dispatch({ type: GET_STATS, stats: response.data, courseId });
        } else {
          dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
              message: "Błąd podczas pobierania statystyk",
              type: "error",
            },
          });
        }
      } catch (e) {
        sessionErrHandler(e, "Błąd podczas pobierania statystyk", dispatch);
      }
      dispatch({ type: HIDE_SPINNER });
      waitingForStats = false;
    }
  };

export const addCourseStats = (id) => (dispatch, getState) => {
  const userState = getState().userState;
  const stats = userState.stats;
  if (!stats[id]) {
    const courseStats = { times: {}, finished: {} };
    const newStats = { ...stats, [id]: courseStats };
    const newUserState = { ...userState, stats: newStats };
    dispatch({ type: SAVE_USER_STATE, userState: newUserState });
  }
};

export const addSectionStats =
  (courseId, sectionId) => (dispatch, getState) => {
    const userState = getState().userState;
    const stats = userState.stats;
    if (!stats[courseId].finished[sectionId]) {
      const newStats = { ...stats };
      newStats[courseId].finished[sectionId] = [];
      const newUserState = { ...userState, stats: newStats };
      dispatch({ type: SAVE_USER_STATE, userState: newUserState });
    }
  };

// Zapisuje statustyki w userState i wywołuje statystyki w api
export const saveStats = (type, secs) => (dispatch, getState) => {
  if (secs < 5) return;
  const key = statsConfig.types[type];
  if (!key) return console.log("invalid stats type: ", type);
  const userState = getState().userState;
  const courseId = userState.currentCourseId;
  const sectionId = userState.currentSectionId;
  if (type !== "MEDIA" && type !== "NOTES")
    dispatch(statsApi(sectionId, type, secs));
  const timestamp = getDailyTimestamp();
  const newStats = { ...userState.stats };
  if (!newStats[courseId].times[timestamp])
    newStats[courseId].times[timestamp] = {};
  const statsTime = newStats[courseId].times[timestamp][key]
    ? newStats[courseId].times[timestamp][key]
    : 0;
  newStats[courseId].times[timestamp][key] = statsTime + secs;
  const newUserState = { ...userState, stats: newStats };
  dispatch(saveUserSatate(clearOutdatedData(newUserState)));
};

export const statsApi = (id, type, secs) => async (dispatch) => {
  const url = `/course/time/${type.toLowerCase()}/${id}`;
  const options = {
    method: "post",
    data: { attemptTimeSeconds: secs },
    url: url,
    withCredentials: true,
  };
  if (type === "GAME") options.url = `/course/time/gameSet/${id}`;
  try {
    await api(options);
  } catch (e) {
    sessionErrHandler(e, "Błąd przesyłania statystyk: " + type, dispatch);
  }
};
